import React from 'react';
import Tenancy from 'app/lib/tenancy';
import Head from 'next/head';

/**
 * @param path - To render just the base URL, pass in a forward slash `/`.
 * Otherwise, pass in the full name of the path e.g `/services`.
 */
export const CanonicalLink: React.FC<{ path: string }> = ({ path }) => {
  const baseUrl = Tenancy.getBaseUrl();
  const link = path !== '/' ? `${baseUrl}${path}`.trim() : baseUrl;

  return (
    <Head>
      <link rel="canonical" href={link} data-testid="canonical-link" />
    </Head>
  );
};
